export const RouteGetMerchflowStores = "/merchflow/stores";

export interface ResponseGetMerchflowStores {
  data: SimpleStore[];
}

export interface SimpleStore {
  storeId: number;
  storeName: string;
  storeCode: string;
}
